import {useEffect} from 'react';
import alertsAction from '../actions/alerts.actions';
import taxAction from '../actions/tax.actions';
import payoutActions from '../actions/payout.actions';
import getAlert from '../components/alert/utils/getAlert';
import isAlertVisible from '../components/alert/utils/isAlertVisible';
import {useSelector, useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {selectAffiliate, selectAlerts, selectConfig} from '../selectors';
import {Alerts, AlertType} from '../reducers/alerts.reducer';

const selectPayout = (state: any) => ({
    loadingAcceptance: state.getIn(['payout', 'loadingAcceptance']),
    closedAccount: state.getIn(['payout', 'closedAccount'])
});

const selectTax = (state: any) => ({
    taxInterviewUrl: state.getIn(['tax', 'taxInterviewUrl']),
    hyperWalletData: state.getIn(['tax', 'hyperWalletData']),
    accountStatus: state.getIn(['tax', 'accountStatus']),
    taxCountrySanctioned: state.getIn(['tax', 'taxCountrySanctioned'])
});

const transformAlerts = (alerts: AlertType[], props): ReturnType<typeof getAlert>[] => {
    return alerts.reduce((prev, alert) => {
        if (isAlertVisible(alert)) {
            const alertItem = getAlert(alert, props);
            if (alertItem) {
                alertItem.type = alert;
                prev.push(alertItem);
            }
        }

        return prev;
    }, []);
};

const useGetAlerts = () => {
    const dispatch = useDispatch();
    const affiliate = useSelector(selectAffiliate);
    const alertsState = useSelector(selectAlerts);
    const taxState = useSelector(selectTax);
    const payoutState = useSelector(selectPayout);
    const configState = useSelector(selectConfig);
    const history = useHistory();

    const {acceptanceStatus} = payoutState.closedAccount || {};
    const accountStatus = taxState && taxState.accountStatus;
    const alerts = alertsState.alerts || [];
    const isLoading = alertsState.loading || payoutState.loadingAcceptance;

    useEffect(() => {
        dispatch(taxAction.getTaxStatus());
    }, [acceptanceStatus]);

    useEffect(() => {
        // if (
        //     (accountStatus && accountStatus !== Alerts.ACCOUNT_ACTIVATED) ||
        //     !hasGoodStandingAlert(alerts)
        // ) {
        //     getAlerts();
        // }

        dispatch(alertsAction.getAlerts());
    }, [accountStatus]);

    useEffect(() => {
        if (!affiliate.oauthViolation && alerts.includes(Alerts.INELIGIBLE_SOCIAL)) {
            dispatch(alertsAction.removeAlerts([Alerts.INELIGIBLE_SOCIAL]));
        }
    }, [affiliate.oauthViolation]);

    return {
        isLoading,
        alerts: transformAlerts(alerts, {
            affiliateAccount: affiliate,
            configState,
            taxState,
            history,
            traceSecurityLink: () => dispatch(payoutActions.traceSecurityLink())
        })
    };
};

export default useGetAlerts;
